import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { SnackBar, Loader } from 'ui/services';
import { uploadAsset as Upload } from 'ui/api/products';
import { Clickable } from 'phoenix-components';
import {
  uploadIcon
} from 'components/shared/Icons/Order';
import styles from './UploadReceipt.module.css';

function UploadReceipt({ setUrl, url }) {

  const inputRef = useRef();

  const uploadAsset = async (e) => {

    try {

      Loader.show();
      const files = e?.target?.files;
      const file = files && files[0];
      const payload = new FormData();
      payload.append('file', file);
      const { url: res } = await Upload(payload);
      setUrl(res);
      SnackBar.show('upload success');
    
    } catch (e) {

      SnackBar.show('upload failed', 'error');
    
    } finally {

      Loader.hide();
    
    }
  
  };

  return (
    <div className={styles.section}>
      <div className={styles.head}>
        Upload Screenshot
      </div>
      <div className={styles.upload}>
        <input
          ref={inputRef}
          accept="image/*"
          hidden
          id="icon-button-file"
          type="file"
          onChange={(e) => {

            uploadAsset(e);
          
          }}
        />
        {url.length > 0 && (
          <Clickable
            onClick={() => {

              // eslint-disable-next-line no-unused-expressions
              inputRef?.current?.click();
            
            }}
            className={styles.uploaded}
          >
            <img src={url} alt="" />
          </Clickable>
        )}
        {url.length === 0 && (
          <div className={styles.toupload}>
            <label htmlFor="icon-button-file">
              <Clickable
                onClick={() => {
                  inputRef?.current?.click();
                }}
              >
                <img src="/images/orders/uplaod.svg" alt="" />
                <span className={styles.top}>
                  {uploadIcon()}
                </span>
              </Clickable>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

UploadReceipt.defaultProps = {
  url: '',
};

UploadReceipt.propTypes = {
  url: PropTypes.string,
  setUrl: PropTypes.func.isRequired
};

export default UploadReceipt;
